module.exports = __webpack_public_path__ + "img/shujuduoweiduguanli.b6874711.png";